(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pp-colour-quicklinks"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pp-colour-quicklinks')) {
    customElements.define('pp-colour-quicklinks', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.controller = new AbortController();
        const track = this.querySelector('.pp-colour-quicklinks__track');
        if (!track) return;
        const options = { signal: this.controller.signal };
        let drag = null;
        let suppressClick = false;
        const previous = this.querySelector('.pp-colour-quicklinks__nav--previous');
        const next = this.querySelector('.pp-colour-quicklinks__nav--next');
        const updateNavigation = () => {
          const scrollable = track.scrollWidth > this.clientWidth + 1;
          this.toggleAttribute('data-scrollable', scrollable);
          previous.hidden = next.hidden = !scrollable;
          previous.disabled = track.scrollLeft <= 1;
          next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
        };
        const move = (direction) => {
          const distance = Math.max(88, Math.floor(track.clientWidth / 88) * 88);
          track.scrollBy({ left: direction * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        };
        previous.addEventListener('click', () => move(-1), options);
        next.addEventListener('click', () => move(1), options);
        track.addEventListener('scroll', updateNavigation, { ...options, passive: true });
        this.resizeObserver = new ResizeObserver(updateNavigation);
        this.resizeObserver.observe(track);

        requestAnimationFrame(() => {
          if (!this.isConnected) return;
          updateNavigation();
          const current = track.querySelector('[aria-current="page"]');
          if (!current) return;
          const trackRect = track.getBoundingClientRect();
          const currentRect = current.getBoundingClientRect();
          if (currentRect.left < trackRect.left || currentRect.right > trackRect.right) {
            track.scrollLeft += currentRect.left - trackRect.left - (track.clientWidth - currentRect.width) / 2;
          }
          updateNavigation();
        });

        const endDrag = (event) => {
          if (!drag || event.pointerId !== drag.id) return;
          suppressClick = drag.moved;
          if (track.hasPointerCapture(event.pointerId)) {
            track.releasePointerCapture(event.pointerId);
          }
          track.removeAttribute('data-dragging');
          drag = null;
        };

        track.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse' || event.button !== 0 || event.ctrlKey || event.metaKey || event.altKey || event.shiftKey) return;
          suppressClick = false;
          drag = { id: event.pointerId, startX: event.clientX, startScroll: track.scrollLeft, moved: false };
        }, options);

        track.addEventListener('pointermove', (event) => {
          if (!drag || event.pointerId !== drag.id) return;
          if (!event.buttons) { endDrag(event); return; }
          const distance = event.clientX - drag.startX;
          if (Math.abs(distance) > 5 && !drag.moved) {
            drag.moved = true;
            track.setPointerCapture(event.pointerId);
            track.setAttribute('data-dragging', '');
          }
          if (drag.moved) {
            event.preventDefault();
            track.scrollLeft = drag.startScroll - distance;
          }
        }, options);

        track.addEventListener('pointerup', endDrag, options);
        track.addEventListener('pointercancel', endDrag, options);
        track.addEventListener('pointerleave', () => {
          if (drag && !drag.moved) drag = null;
        }, options);
        track.addEventListener('dragstart', (event) => event.preventDefault(), options);
        track.addEventListener('click', (event) => {
          if (suppressClick && event.detail > 0) {
            event.preventDefault();
            event.stopImmediatePropagation();
            suppressClick = false;
          }
        }, { ...options, capture: true });

        track.addEventListener('wheel', (event) => {
          if (event.ctrlKey || Math.abs(event.deltaX) >= Math.abs(event.deltaY)) return;
          const factor = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? track.clientWidth : 1;
          const next = Math.max(0, Math.min(track.scrollWidth - track.clientWidth, track.scrollLeft + event.deltaY * factor));
          if (Math.abs(next - track.scrollLeft) > 0.5) {
            event.preventDefault();
            track.scrollLeft = next;
          }
        }, { ...options, passive: false });

        track.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          const link = event.target.closest('.pp-colour-quicklinks__link');
          if (!link) return;
          const item = event.key === 'ArrowRight' ? link.parentElement.nextElementSibling : link.parentElement.previousElementSibling;
          const nextLink = item?.querySelector('.pp-colour-quicklinks__link');
          if (nextLink) {
            event.preventDefault();
            nextLink.focus();
          }
        }, options);
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
